import { RfiType } from '../sdk';

export const getRfiTypeFieldsInUse = (rfiType: RfiType) => {
  const fieldsInUse = [];

  if (rfiType.projectReviewer && rfiType.projectReviewer.length > 0) {
    fieldsInUse.push('reviewer');
  }

  if (rfiType.projectCoordinator && rfiType.projectCoordinator.length > 0) {
    fieldsInUse.push('coordinator');
  }

  if (rfiType.manager && rfiType.manager.length > 0) {
    fieldsInUse.push('manager');
  }

  if (rfiType.watchers && rfiType.watchers.length > 0) {
    fieldsInUse.push('watchers');
  }

  if (rfiType.dueDateOffset) {
    fieldsInUse.push('due_date_offset');
  }

  if (rfiType.locationDescription) {
    fieldsInUse.push('location_details');
  }

  if (rfiType.costImpact) {
    fieldsInUse.push('cost_impact');
  }

  if (rfiType.scheduleImpact) {
    fieldsInUse.push('schedule_impact');
  }

  if (rfiType.priority) {
    fieldsInUse.push('priority');
  }

  if (rfiType.discipline && rfiType.discipline.length > 0) {
    fieldsInUse.push('discipline');
  }

  if (rfiType.category && rfiType.category.length > 0) {
    fieldsInUse.push('category');
  }

  if (rfiType.reference) {
    fieldsInUse.push('external_id');
  }

  return fieldsInUse;
};
